module.exports = __webpack_public_path__ + "static/media/DA-Bird_falling.70bf8c90.png";